<div class="last-updated-container" [ngClass]="{'container--card': isCardView, 'overdue': isOverdue()}">
  <ng-container *ngIf="issue && issue.updatedAt">
    <span class="last-updated-label">Last Updated:</span>
    <span class="last-updated-time">
      {{ issue.updatedAt | timeAgo }}
    </span>
  </ng-container>
</div>
